import { CheckCircle2 } from "lucide-react";
import { Reveal } from "../lib/motion";

const PROVIDER_BULLETS = [
  "Detox and treatment centers",
  "PHP, IOP, and outpatient programs",
  "MAT providers",
  "Sober living residences",
  "Halfway houses",
  "Therapists and recovery professionals",
  "Community and recovery organizations",
];

export const WhoWeHelp = () => (
  <section id="who" className="relative bg-[#FAFAF9] py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <Reveal className="max-w-3xl">
        <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#0891B2] mb-4">
          Who We Help
        </p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#3B3A4E] leading-tight">
          Here to Help You While You're Helping Others
        </h2>
      </Reveal>

      <div className="mt-12 grid lg:grid-cols-2 gap-6 lg:gap-8">
        <Reveal>
          <div className="h-full rounded-3xl bg-[#1F1D2B] text-white p-8 sm:p-10 shadow-xl shadow-[#3B3A4E]/20 relative overflow-hidden">
            <div className="pointer-events-none absolute -top-16 -right-16 h-48 w-48 rounded-full bg-[#1AD1B9]/20 blur-3xl" />
            <div className="relative">
              <div className="mb-6 rounded-2xl overflow-hidden aspect-[16/10] bg-[#F5F4F1] ring-1 ring-white/10">
                <img
                  src="https://static.prod-images.emergentagent.com/jobs/dc8a482d-361d-4996-9eb5-a4cbac9ec941/images/1a5b524dd4a7c1eca472a1aa8bcf3c2e645ffc73ef57d15171cc911cfcff1b7a.jpeg"
                  alt="Illustration of Michael coordinating transportation support with a friendly treatment-center staff member"
                  className="h-full w-full object-cover"
                />
              </div>
              <h3 className="text-xl sm:text-2xl font-heading font-semibold">
                For Treatment and Recovery Providers
              </h3>
              <p className="mt-4 text-white/75 leading-relaxed">
                Staffing shortages and unexpected transportation needs can pull your team away from the work
                that matters most. Recovery Rides acts as dependable backup for admissions, discharges,
                appointments, store trips, laboratory deliveries, and other day-to-day transportation
                challenges.
              </p>
              <ul className="mt-7 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                {PROVIDER_BULLETS.map((b) => (
                  <li key={b} className="flex items-start gap-2.5 text-sm text-white/85">
                    <CheckCircle2 size={18} className="text-[#1AD1B9] shrink-0 mt-0.5" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="h-full rounded-3xl bg-white border border-[#3B3A4E]/8 p-8 sm:p-10 shadow-sm relative overflow-hidden">
            <div className="pointer-events-none absolute -bottom-16 -left-16 h-48 w-48 rounded-full bg-[#1AD1B9]/10 blur-3xl" />
            <div className="relative">
              <div className="mb-6 rounded-2xl overflow-hidden aspect-[16/10] bg-[#F5F4F1] ring-1 ring-[#3B3A4E]/8">
                <img
                  src="https://static.prod-images.emergentagent.com/jobs/dc8a482d-361d-4996-9eb5-a4cbac9ec941/images/aa47617d3bffe09ac9c185fcdcc174d78261750837f356fb500e2ba881224c77.jpeg"
                  alt="Illustration of Michael warmly welcoming a family beside a Recovery Rides vehicle outside their home"
                  className="h-full w-full object-cover"
                />
              </div>
              <h3 className="text-xl sm:text-2xl font-heading font-semibold text-[#2D2B3D]">
                For Individuals and Families
              </h3>
              <p className="mt-4 text-[#5C5975] leading-relaxed">
                You do not need to be connected to a treatment provider to request service. Recovery Rides is
                available to individuals, families, and anyone who needs dependable transportation, with
                specialized understanding for passengers affected by substance use disorder and recovery.
              </p>
              <div className="mt-7 rounded-2xl bg-[#FAFAF9] border border-[#3B3A4E]/8 p-5">
                <p className="text-sm font-medium text-[#3B3A4E] leading-relaxed">
                  “We believe every person deserves to get where they need to go with dignity, encouragement,
                  and someone who understands what the journey means.”
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
